import { render } from "./Books.vue?vue&type=template&id=3fc65764&scoped=true"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"

import "./Books.vue?vue&type=style&index=0&id=3fc65764&scoped=true&lang=css"
import "./Books.vue?vue&type=style&index=1&id=3fc65764&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc65764"]])

export default __exports__